import React, { useMemo } from "react";
import { Route, Redirect } from "react-router-dom";
import { LAYOUTS } from "constant";

/* Services */
import { getAuthToken } from "services/Auth.service";

/* Components */
import Footer from "components/layout/Footer";
import ErrorBoundary from "components/utils/ErrorBoundary";
import { isHistoryAllowed, isImportAllowed, isOrderCreationAllowed, isTrackAllowed } from "helpers/permission.helper";
import ROUTE_PATHS from "constant/routePaths";

const RouteWithProps: React.FC<any> = ({
  props,
  layout,
  setLayout,
  isAuth,
  component: Component,
  className,
  userPermissions,
  ...rest
}) => {
  
  const redirectPath = useMemo(()=>{
    if(isTrackAllowed(userPermissions)) return ROUTE_PATHS.TRACK;
    if(isOrderCreationAllowed(userPermissions)) return ROUTE_PATHS.CREATE_ORDER;
    if(isImportAllowed(userPermissions)) return ROUTE_PATHS.IMPORT_LIST;
    if(isHistoryAllowed(userPermissions)) return ROUTE_PATHS.HISTORY;
    return ROUTE_PATHS.NO_PERMISSION;
  },[userPermissions]);

  return (
    <Route
      {...rest}
      exact
      render={(matchProps) => {
        let isLoggedIn = getAuthToken();
        if (isAuth && isLoggedIn) {
          return (
            <Redirect
              to={{
                pathname: redirectPath,
                state: { from: matchProps.location },
              }}
            />
          );
        }
        if (setLayout) {
          setLayout(layout);
        }

        switch (layout) {
          case LAYOUTS.DEFAULT:
            return (
              <main className={`main-panel p-0 ${className} main-panel-public`}>
                <div className="main">
                  <ErrorBoundary>
                    <Component {...matchProps} {...props} />
                  </ErrorBoundary>
                </div>
                <Footer />
              </main>
            );
          case LAYOUTS.COMPACT:
            return (
              <main className={`main-panel-2 ${className} main-panel-public`}>
                <div className="main">
                  <ErrorBoundary>
                    <Component {...matchProps} {...props} />
                  </ErrorBoundary>
                </div>
                <Footer isFullWidth />
              </main>
            );
          case LAYOUTS.AUTH:
            return (
              <ErrorBoundary>
                <Component {...matchProps} {...props} />
              </ErrorBoundary>
            );

          default:
            break;
        }
      }}
    />
  );
};

export default RouteWithProps;
